import LoginRegister from "./Component/LoginRegister/LoginRegister";
function App() {
  return (
    <div>
      <LoginRegister />
    </div>
  );
}

export default App;
